import { render, staticRenderFns } from "./XDialog.vue?vue&type=template&id=a19b101e&scoped=true"
import script from "./XDialog.vue?vue&type=script&lang=js"
export * from "./XDialog.vue?vue&type=script&lang=js"
import style0 from "./XDialog.vue?vue&type=style&index=0&id=a19b101e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19b101e",
  null
  
)

export default component.exports